import type {
    ContentBlock,
    IServerToolResultBlock,
    PersistedContentBlock,
} from "./chat.types";

function isServerToolResultBlock(
    block: PersistedContentBlock
): block is IServerToolResultBlock {
    const type: string = block.type;
    return type !== "tool_result" && type.endsWith("_tool_result");
}

function isServerManagedToolUse(
    block: PersistedContentBlock,
    blocks: PersistedContentBlock[],
    index: number
): boolean {
    if (block.type !== "tool_use") return false;
    if (block.name === "code_execution") {
        return true;
    }
    return blocks
        .slice(index + 1)
        .some(
            (candidate) =>
                isServerToolResultBlock(candidate) &&
                candidate.tool_use_id === block.id
        );
}

export function isDisplayContentBlock(
    block: PersistedContentBlock,
    blocks: PersistedContentBlock[],
    index: number
): block is ContentBlock {
    if (isServerManagedToolUse(block, blocks, index)) return false;
    const type: string = block.type;
    return !(
        type === "redacted_thinking" ||
        type === "server_tool_use" ||
        type === "code_execution" ||
        type === "text_editor_code_execution" ||
        type === "bash_code_execution" ||
        type === "tool_result" ||
        isServerToolResultBlock(block)
    );
}
